(function () {
  async function fetchCartSubtotal() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      return cart.original_total_price || 0;
    } catch (e) {
      return 0;
    }
  }

  function getMultiplierForTotal(totalCents) {
    if (totalCents >= 9000) return 0.90;
    if (totalCents >= 6500) return 0.95;
    return 1.0;
  }

  function calculateFinalPrice(totalCents, isSubscription) {
    const multiplier = getMultiplierForTotal(totalCents);
    const price = isSubscription ? totalCents * 0.90 * multiplier : totalCents * multiplier;
    return Math.round(price);
  }

  function calculateBundlePriceWithCartContext(bundleTotalCents, totalCombinedCents, isSubscription) {
    const multiplier = getMultiplierForTotal(totalCombinedCents);
    const price = isSubscription
      ? bundleTotalCents * 0.90 * multiplier
      : bundleTotalCents * multiplier;
    return Math.round(price);
  }

  window.BundleState = {
    cartSubtotalCents: 0,
    fetchCartSubtotal,
    getMultiplierForTotal,
    calculateFinalPrice,
    calculateBundlePriceWithCartContext,
  };

  document.addEventListener('DOMContentLoaded', async () => {
    window.BundleState.cartSubtotalCents = await fetchCartSubtotal();
    document.dispatchEvent(new CustomEvent('bundle:cart-loaded'));
  });

  // Fallback natif Impact (conservé si l'utilisateur vire Kaching Cart)
  document.documentElement.addEventListener('cart:change', (e) => {
    if (e.detail?.cart?.original_total_price !== undefined) {
      window.BundleState.cartSubtotalCents = e.detail.cart.original_total_price;
    } else {
      fetchCartSubtotal().then(v => { window.BundleState.cartSubtotalCents = v; });
    }
    document.dispatchEvent(new CustomEvent('bundle:cart-loaded'));
  });

  // Intercept fetch — compatible Kaching Cart et toute app cart tierce
  if (!window.__bundleStateFetchWrapped) {
    window.__bundleStateFetchWrapped = true;
    const origFetch = window.fetch;
    window.fetch = async function(...args) {
      const result = await origFetch.apply(this, args);

      let url = '';
      if (typeof args[0] === 'string') {
        url = args[0];
      } else if (args[0] instanceof Request) {
        url = args[0].url;
      } else if (args[0]?.url) {
        url = args[0].url;
      }

      if (url && /\/cart\/(add|change|update|clear)/i.test(url)) {
        setTimeout(async () => {
          try {
            window.BundleState.cartSubtotalCents = await fetchCartSubtotal();
            document.dispatchEvent(new CustomEvent('bundle:cart-loaded'));
          } catch (e) {
            console.error('[BundleState] Error refreshing cart:', e);
          }
        }, 200);
      }

      return result;
    };
  }
})();
